import { LendPeak } from '../../LendPeak';
import { Amortization } from '../../Amortization';
import { DepositRecords } from '../../DepositRecords';
import { DepositRecord } from '../../DepositRecord';
import { LocalDate, ChronoUnit } from '@js-joda/core';
import { TermCalendars } from '../../TermCalendars';
import { Calendar, CalendarType } from '../../Calendar';
const today = LocalDate.now().minus(5, ChronoUnit.DAYS);
export class DemoC8 {
    static LendPeakObject() {
        return new LendPeak({
            amortization: new Amortization({
                id: 'DEMO-C08',
                name: 'DEMO-C08',
                description: 'Alt day-count basis',
                startDate: today.minus(13, ChronoUnit.MONTHS),
                originationFee: 100,
                loanAmount: 19_900,
                interestAccruesFromDayZero: true,
                annualInterestRate: 0.1355,
                term: 24,
                calendars: new TermCalendars({
                    primary: new Calendar(CalendarType.THIRTY_360),
                }),
                defaultPreBillDaysConfiguration: 28,
            }),
            depositRecords: new DepositRecords([
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(12, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-1',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(11, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-2',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(10, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-3',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(9, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-4',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(8, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-5',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(7, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-6',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(6, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-7',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(5, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-8',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(4, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-9',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(3, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-10',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(2, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-11',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today.minus(1, ChronoUnit.MONTHS),
                    id: 'DEPOSIT-C08-12',
                    currency: 'USD',
                }),
                new DepositRecord({
                    amount: 956.01,
                    effectiveDate: today,
                    id: 'DEPOSIT-C08-13',
                    currency: 'USD',
                }),
            ]),
        });
    }
    static ImportObject() {
        const lendPeak = DemoC8.LendPeakObject();
        return {
            loan: lendPeak.amortization,
            deposits: lendPeak.depositRecords,
        };
    }
}
